module.exports = __webpack_public_path__ + "img/case-bj33.f207e692.png";